import { Members } from '@/components/settings/team';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/team')({
  component: Team,
});

function Team() {
  return (
    <div className='pt-6 space-y-6'>
      <Members />
    </div>
  );
}
